export default "__VITE_ASSET__DZt5io13__"